import BaseModel from '../base/BaseModel.model';
import { BudgetItemCalculation } from '@/enums/BudgetItemCalculation';
export default class BudgetItem extends BaseModel {

   public name?: string;
   public budgetExpenseId?:number | null;
   public budgetItemCalculation?: BudgetItemCalculation;
   public hasIncludeInAnualRuleOfPayOfFondocyt:boolean = false;
   public hasRuleForPercentageLimitBasedInSubTotal:boolean = false;
   public percentageLimitBasedInSubTotal:number = null;
   public index?: number;
   constructor(){
       super();
       this.init();
   }

    init(){
       this.name = "";
       this.budgetExpenseId = null;
       this.budgetItemCalculation = BudgetItemCalculation.UNIDADXCOSTOUNITARIO;
       this.hasIncludeInAnualRuleOfPayOfFondocyt = false;
       this.hasRuleForPercentageLimitBasedInSubTotal = false;
       this.percentageLimitBasedInSubTotal = null;
       this.index = null;
    }

}